import script from "./testAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./testAgent.vue?vue&type=script&setup=true&lang=js"

import "./testAgent.vue?vue&type=style&index=0&id=0d54ffd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d54ffd4"]])

export default __exports__